import type { Verse } from './types.js';

/**
 * Fallback verses. Rendered when the PWA is offline or /api/verses fails.
 * Also used as the initial pool on first paint before any fetch.
 */
export const FALLBACK_VERSES: Verse[] = [
  { text: 'Be transformed by the renewing of your mind.', ref: 'Romans 12:2' },
  { text: 'You are a chosen people, a royal priesthood, a holy nation.', ref: '1 Peter 2:9' },
  { text: "For we are God's handiwork, created in Christ Jesus.", ref: 'Ephesians 2:10' },
  { text: 'The Lord is my light and my salvation — whom shall I fear?', ref: 'Psalm 27:1' },
  { text: 'Set your minds on things above, not on earthly things.', ref: 'Colossians 3:2' },
  { text: 'He has made everything beautiful in its time.', ref: 'Ecclesiastes 3:11' },
];

export const FONTS = {
  display: "'Fraunces', Georgia, 'Times New Roman', serif",
  body: "'Figtree', system-ui, -apple-system, sans-serif",
  mono: "'JetBrains Mono', ui-monospace, 'SF Mono', monospace",
} as const;

export const COLORS = {
  cream: '#F5F1E8',
  ink: '#1A1613',
  accent: '#B8472E',
  muted: '#8B6F4A',
  sand: '#D9CDB8',
} as const;

/** Splash auto-dismiss. Must match Playwright timing expectations. */
export const SPLASH_DURATION_MS = 3200;

/** KV cache TTL for products (seconds). */
export const PRODUCTS_KV_TTL_SEC = 60;
/** KV cache TTL for verses (seconds). */
export const VERSES_KV_TTL_SEC = 600;

export const UTM_SOURCE = 'setapart';
export const UTM_MEDIUM = 'app';
export const UTM_CAMPAIGN = 'v1';
